import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth/services/auth.service';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserState } from 'src/app/auth/store/user/user.state';
import { getUser } from 'src/app/auth/store/user/user.selector';

@Component({
  selector: 'app-caaks-user-panel',
  templateUrl: './caaks-userpanel.template.html',
  styleUrls: ['./caaks-userpanel.style.scss'],

  standalone: false,})
export class CaaksUserPanelComponent implements OnInit {
  // @HostBinding("[class.caaks-hidden]") get authEnabled() {
  //   return this.isAuthEnabled() === false;
  // }

  username: string | undefined = '';
  userRole: string | undefined = '';
  loginStatus: boolean = false;
  isLoginStatusInitialized = false;
  user$: Observable<UserState>;
  userRole$: Observable<string | undefined>;

  private readonly roleLabels: Record<string, string> = {
    admin_sbvp: 'Administrateur',
    admin_application: 'Admin Application',
    developer_application: 'Développeur',
    customer: 'Client',
  };

  constructor(
    private store: Store<{ user: UserState }>,
    private userLogin: AuthService,
  ) {
    this.user$ = this.store.pipe(select(getUser));
    this.userRole$ = this.user$.pipe(
      map(user => (user?.sbvpRole ? this.roleLabels[user.sbvpRole] ?? user.sbvpRole : undefined)),
    );
  }

  get hasUsername(): boolean {
    return !!this.user$.subscribe(result => result.username);
  }

  ngOnInit(): void {
    this.loginStatus = this.userLogin.isAuthenticated;
    this.isLoginStatusInitialized = true;
    this.user$.subscribe(result => {
      this.username = result.username;
      this.loginStatus = !!result;
      this.userRole = result?.sbvpRole
        ? this.roleLabels[result.sbvpRole] ?? result.sbvpRole
        : undefined;
    });
  }

  isAuthSkipped(): boolean {
    return this.loginStatus;
  }

  isLoggedIn(): boolean {
    return this.loginStatus;
  }

  isAuthEnabled(): boolean {
    return this.loginStatus;
  }

  async login(): Promise<void> {
    await this.userLogin.login();
  }

  logout(): void {
    this.userLogin.logout().subscribe({
      next: () => console.log('Logout successful'),
      error: err => console.error('Logout error:', err),
    });
  }

  close(): void {}
}
